<template>
    <div class="admin-users">
        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2026<br>Sanitäts- und Rettungsdienst</span>
                    <div>
                        <img src="../../assets/logo-drk.svg" class="logo-image"/>
                        <br>
                        <el-button type="danger" @click="logout">Abmelden</el-button>
                        <br>
                        <router-link to="/admin/dashboard">
                            <el-button type="primary" style="margin-top: 5px;">Zurück zum Admin-Dashboard</el-button>
                        </router-link>
                        <br>
                        <password/>
                    </div>
                </div>
            </template>
            <el-card>
                <template #header>
                    <div class="card-header">
                        <h2>Benutzerverwaltung</h2>
                        <el-button type="primary" @click="openCreateDialog">Neuer Benutzer</el-button>
                    </div>
                </template>

            <el-table :data="users" stripe style="width: 100%" table-layout="fixed">
                    <el-table-column prop="name" label="Name" min-width="150" />
                    <el-table-column prop="email" label="E-Mail" min-width="200" />
                    <el-table-column prop="unit" label="Einheit" min-width="180" />
                    <el-table-column prop="role" label="Rolle" min-width="100">
                        <template #default="{ row }">
                            {{ getRoleName(row.role) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Aktionen" width="100">
                        <template #default="{ row }">
                            <div style="display: flex; gap: 5px;">
                                <el-tooltip content="Bearbeiten" placement="top">
                                    <el-button type="primary" size="small" :icon="Edit" @click="openEditDialog(row)"/>
                                </el-tooltip>
                                <el-tooltip content="Löschen" placement="top">
                                    <el-button type="danger" size="small" :icon="Delete" @click="deleteUser(row)"/>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-card>

        <!-- Dialog für neuen Benutzer -->
        <el-dialog v-model="showCreateDialog" title="Neuen Benutzer anlegen" width="500px">
            <el-form :model="newUser" :rules="createRules" ref="createForm" label-width="140px">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="newUser.name" placeholder="Vollständiger Name" />
                </el-form-item>
                <el-form-item label="E-Mail" prop="email">
                    <el-input v-model="newUser.email" placeholder="E-Mail Adresse" />
                </el-form-item>
                <el-form-item label="Passwort" prop="password">
                    <el-input v-model="newUser.password" type="password" placeholder="Passwort" show-password />
                </el-form-item>
                <el-form-item label="Passwort bestätigen" prop="c_password">
                    <el-input v-model="newUser.c_password" type="password" placeholder="Passwort wiederholen" show-password />
                </el-form-item>
                <el-form-item label="Einheit" prop="unit">
                    <el-input v-model="newUser.unit" placeholder="z.B. DRK KV Harburg Land" />
                </el-form-item>
                <el-form-item label="Bereich" prop="area">
                    <el-select v-model="newUser.area" placeholder="Bereich auswählen" style="width: 100%">
                        <el-option v-for="opt in areaOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Rolle" prop="role">
                    <el-select v-model="newUser.role" placeholder="Rolle auswählen" style="width: 100%">
                        <el-option label="Benutzer" :value="0" />
                        <el-option label="Einheitsleiter" :value="1" />
                        <el-option label="Verpflegung" :value="2" />
                        <el-option label="Admin" :value="99" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showCreateDialog = false">Abbrechen</el-button>
                <el-button type="primary" @click="createUser">Anlegen</el-button>
            </template>
        </el-dialog>

        <!-- Dialog für Bearbeiten -->
        <el-dialog v-model="showEditDialog" title="Benutzer bearbeiten" width="500px">
            <el-form :model="editUser" :rules="editRules" ref="editForm" label-width="140px">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="editUser.name" placeholder="Vollständiger Name" />
                </el-form-item>
                <el-form-item label="E-Mail" prop="email">
                    <el-input v-model="editUser.email" placeholder="E-Mail Adresse" />
                </el-form-item>
                <el-form-item label="Neues Passwort">
                    <el-input v-model="editUser.password" type="password" placeholder="Leer lassen für keine Änderung" show-password />
                </el-form-item>
                <el-form-item label="Einheit" prop="unit">
                    <el-input v-model="editUser.unit" placeholder="z.B. DRK KV Harburg Land" />
                </el-form-item>
                <el-form-item label="Bereich" prop="area">
                    <el-select v-model="editUser.area" placeholder="Bereich auswählen" style="width: 100%">
                        <el-option v-for="opt in areaOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Rolle" prop="role">
                    <el-select v-model="editUser.role" placeholder="Rolle auswählen" style="width: 100%">
                        <el-option label="Benutzer" :value="0" />
                        <el-option label="Einheitsleiter" :value="1" />
                        <el-option label="Verpflegung" :value="2" />
                        <el-option label="Admin" :value="99" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showEditDialog = false">Abbrechen</el-button>
                <el-button type="primary" @click="updateUser">Speichern</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Axios from "axios";
import { ElNotification, ElMessageBox } from "element-plus";
import Password from "@/components/password.vue";
import { Edit, Delete } from '@element-plus/icons-vue';

export default {
    name: "AdminUsers",
    components: { Password },
    setup() {
        return { Edit, Delete };
    },
    data() {
        return {
            users: [],
            showCreateDialog: false,
            showEditDialog: false,
            areaOptions: [
                { value: 1, label: 'BHP' }
            ],
            newUser: {
                name: '',
                email: '',
                password: '',
                c_password: '',
                unit: '',
                area: 0,
                role: 0
            },
            editUser: {
                id: null,
                name: '',
                email: '',
                password: '',
                unit: '',
                area: 0,
                role: 0
            },
            createRules: {
                name: [{ required: true, message: 'Bitte Namen eingeben', trigger: 'blur' }],
                email: [
                    { required: true, message: 'Bitte E-Mail eingeben', trigger: 'blur' },
                    { type: 'email', message: 'Bitte gültige E-Mail eingeben', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: 'Bitte Passwort eingeben', trigger: 'blur' },
                    { min: 6, message: 'Passwort muss mindestens 6 Zeichen haben', trigger: 'blur' }
                ],
                c_password: [
                    { required: true, message: 'Bitte Passwort bestätigen', trigger: 'blur' }
                ],
                unit: [{ required: true, message: 'Bitte Einheit eingeben', trigger: 'blur' }],
                area: [{ required: true, message: 'Bitte Bereich auswählen', trigger: 'change' }],
                role: [{ required: true, message: 'Bitte Rolle auswählen', trigger: 'change' }]
            },
            editRules: {
                name: [{ required: true, message: 'Bitte Namen eingeben', trigger: 'blur' }],
                email: [
                    { required: true, message: 'Bitte E-Mail eingeben', trigger: 'blur' },
                    { type: 'email', message: 'Bitte gültige E-Mail eingeben', trigger: 'blur' }
                ],
                unit: [{ required: true, message: 'Bitte Einheit eingeben', trigger: 'blur' }],
                area: [{ required: true, message: 'Bitte Bereich auswählen', trigger: 'change' }],
                role: [{ required: true, message: 'Bitte Rolle auswählen', trigger: 'change' }]
            }
        };
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        getRoleName(role) {
            switch (role) {
                case 99: return 'Admin';
                case 2: return 'Verpflegung';
                case 1: return 'Einheitsleiter';
                default: return 'Benutzer';
            }
        },
        async loadUsers() {
            try {
                const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/users`);
                if (response.data && response.data.data) {
                    this.users = response.data.data;
                }
            } catch (error) {
                console.log('Benutzer laden fehlgeschlagen:', error);
                ElNotification({
                    title: 'Fehler',
                    message: 'Benutzer konnten nicht geladen werden',
                    type: 'error'
                });
            }
        },
        openCreateDialog() {
            this.resetCreateForm();
            this.showCreateDialog = true;
        },
        openEditDialog(user) {
            this.editUser = {
                id: user.id,
                name: user.name,
                email: user.email,
                password: '',
                unit: user.unit,
                area: user.area != null ? Number(user.area) : 0,
                role: user.role
            };
            this.showEditDialog = true;
        },
        async createUser() {
            try {
                await this.$refs.createForm.validate();

                if (this.newUser.password !== this.newUser.c_password) {
                    ElNotification({
                        title: 'Fehler',
                        message: 'Passwörter stimmen nicht überein',
                        type: 'error'
                    });
                    return;
                }

                const params = new URLSearchParams();
                params.append('name', this.newUser.name);
                params.append('email', this.newUser.email);
                params.append('password', this.newUser.password);
                params.append('c_password', this.newUser.c_password);
                params.append('unit', this.newUser.unit);
                params.append('area', this.newUser.area);
                params.append('role', this.newUser.role);

                await Axios.post(`${process.env.VUE_APP_API_URL}/api/register?${params.toString()}`);

                ElNotification({
                    title: 'Erfolg',
                    message: 'Benutzer wurde erfolgreich angelegt',
                    type: 'success'
                });

                this.showCreateDialog = false;
                this.loadUsers();
            } catch (error) {
                ElNotification({
                    title: 'Fehler',
                    message: error.response?.data?.message || 'Benutzer konnte nicht angelegt werden',
                    type: 'error'
                });
            }
        },
        async updateUser() {
            try {
                await this.$refs.editForm.validate();

                const data = {
                    name: this.editUser.name,
                    email: this.editUser.email,
                    unit: this.editUser.unit,
                    area: this.editUser.area,
                    role: this.editUser.role
                };

                if (this.editUser.password) {
                    data.password = this.editUser.password;
                }

                await Axios.put(`${process.env.VUE_APP_API_URL}/api/users/${this.editUser.id}`, data);

                ElNotification({
                    title: 'Erfolg',
                    message: 'Benutzer wurde erfolgreich aktualisiert',
                    type: 'success'
                });

                this.showEditDialog = false;
                this.loadUsers();
            } catch (error) {
                ElNotification({
                    title: 'Fehler',
                    message: error.response?.data?.message || 'Benutzer konnte nicht aktualisiert werden',
                    type: 'error'
                });
            }
        },
        async deleteUser(user) {
            try {
                await ElMessageBox.confirm(
                    `Möchten Sie den Benutzer "${user.name}" wirklich löschen?`,
                    'Benutzer löschen',
                    {
                        confirmButtonText: 'Löschen',
                        cancelButtonText: 'Abbrechen',
                        type: 'warning'
                    }
                );

                await Axios.delete(`${process.env.VUE_APP_API_URL}/api/users/${user.id}`);

                ElNotification({
                    title: 'Erfolg',
                    message: 'Benutzer wurde erfolgreich gelöscht',
                    type: 'success'
                });

                this.loadUsers();
            } catch (error) {
                if (error !== 'cancel') {
                    ElNotification({
                        title: 'Fehler',
                        message: error.response?.data?.message || 'Benutzer konnte nicht gelöscht werden',
                        type: 'error'
                    });
                }
            }
        },
        resetCreateForm() {
            this.newUser = {
                name: '',
                email: '',
                password: '',
                c_password: '',
                unit: '',
                area: 0,
                role: 0
            };
            if (this.$refs.createForm) {
                this.$refs.createForm.resetFields();
            }
        }
    },
    async created() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/');
            return;
        }
        if (this.$store.getters.getRole !== 99) {
            this.$router.push('/unitdashboard');
            return;
        }
        this.loadUsers();
    }
};
</script>

<style scoped>
.admin-users {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.box-card {
    max-width: 1100px;
    flex: auto;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}
</style>
